import LanguageService from '../../../service/LanguageService';
import ValidService from '../../../service/ValidService'
let model = {};
// dữ liệu form
model.dataForm = {
    "employee_no": undefined, // required, pattern: //^[A-Z0-9]+$//, minLength: 2, maxLength: 28 Mã nhân viên
    "company_id": undefined, // required Công ty Id
    "image_id": undefined, // optional, ref: mushroom_file - Ảnh cá nhân
    "administrative_info": // required Thông tin hành chính
    {
        "name": // required Tên nhân viên
        {
            "first_name": undefined, // required Tên
            "last_name": undefined, // required Họ và đệm
            "full_name": undefined, // required Họ tên đầy đủ
        },
        "avatar_id": undefined, // required Ảnh chân dung
        "birthday": undefined, // required Ngày sinh
        "gender": undefined, // required, min: 0, max: 2 Giới tính 0: nữ, 1: nam, 2: khác
        "identify_card": undefined, // required Số chứng mình thư, căn cước công dân
        "identify_before_img_id": undefined, // optional Ảnh cmt/cccd trước
        "identify_after_img_id": undefined, // optional Ảnh cmt/cccd sau
        "phone_number": undefined, // required Điện thoại
        "email": undefined, // required Email cá nhân
        "company_email": undefined, // optional Email công ty
        "address": undefined, // optional Địa chỉ
        "skype": undefined, // optional Skype
        "facebook": undefined, // optional facebook
    },
    "status": undefined, // optional Trạng thái làm việc
    "card_no": undefined, // optional Mã thẻ chấm công
    "account": undefined,
    "job_info": [{
        "kind_of_contract": undefined, // optional, enum(LABOR, PERSONNEL) - Kiểu hợp đồng (Lao động hoặc nhân sự)
        "contract_type_id": undefined, // required Loại hợp đồng
        "start_date": undefined, // required Ngày bắt đầu
        "end_date": undefined, // optional Ngày kết thúc
        "official_labor_contract_signed_date": undefined, // optional Ngày kí HĐLĐ chính thức
        "branch_id": undefined, // optional Chi nhánh
        "department_id": undefined, // optional Phòng ban
        "position_id": undefined, // optional Chức vụ
        "direct_manager_id": undefined, // required Quản lý trực tiếp
    }],
    "qualification": Array(),
    "certificate": Array(),
    "other_contact_info": Array(),
    "salary": // optional Thông tin về lương
    {
        "payment_method": undefined, // optional Hình thức chi trả
        "bank_name": undefined, // optional Tên ngân hàng
        "bank_account": undefined, // optional Số ngân hàng
        "bank_branch": undefined, // optional Chi nhánh ngân hàng
        "coefficient_salary_id": undefined, // optional Hệ số lương
        "rank_salary_id": undefined, // optional Bậc lương
        "gross_salary": undefined, // optional Mức lương gross
        "insurance_salary": undefined, // optional Mức lương đóng bảo hiểm
        "subsidies_salary": Array({
          "subsidies_salary_type_id": undefined, // required Tên loại phụ cấp
          "value": undefined, // required Giá trị phụ cấp
        }),
    },
    "dependent_person_info": Array(),
    "shift": [{
        "shift_id": undefined, // required Ca làm việc
        "employee_id": undefined, // required Mã nhân viên
        "company_id": undefined, // required Mã công ty - lưu dư thừa
        "start_time": undefined, // required Thời điểm bắt đầu
        "end_time": undefined, // optional Thời điểm kết thúc
        "is_need_checkin": true, // required Có cần chấm công không
        "number_of_late_minute": undefined, // optional Số phút cho phép đi muộn
        "number_of_leave_early_minute": undefined, // optional Số phút cho phép về sớm
    }],
    "social_networks": Array(),
    "seniority": 0, // optional - Số năm thâm niên
    "start_work_date": undefined, // optional - Ngày đầu làm việc
    "insurance_book_number": undefined, // optional - Số sổ bảo hiểm
    "file_ids": Array(), // optional File hồ sơ
    "disabled": undefined, // required Đã bị khóa chưa,
    "image_ids": Array(), // optional Ảnh chữ ký
    "organization_model_id": null,
};
// validation form
model.validForm = {
    "account": [
        ValidService.required,
        ValidService.checkSpaceString,
        {
            pattern: /^[_.a-zA-Z0-9]+$/g,
            message: LanguageService.lang.valid_script,
            trigger: "blur"
        },
        ValidService.checkLength1(4, 12)
    ],
    "employee_no": [
        ValidService.required,
        ValidService.checkSpaceString,
        ValidService.checkLength1(1, 32),
        {
            pattern: /^[A-Z0-9]+$/,
            message: "Mã nhân viên chỉ gồm chữ in hoa A-Z và số 0-9, không chứa khoảng trắng hoặc ký tự đặc biệt (ví dụ: UDS114)",
            trigger: ["blur", "change"]
        },
        // {
        //     pattern: /(0|[^a-zA-Z0-9]+)+$/g,
        //     message: "Mã nhân viên không được bắt đầu bằng 0",
        //     trigger: "blur"
        // },
    ], // required, pattern: //^[A-Z0-9]+$//, minLength: 2, maxLength: 28 Mã nhân viên
    "company_id": [ValidService.required], // required Công ty Id
    "administrative_info": // required Thông tin hành chính
    {
        "name": // required Tên nhân viên
        {
            "first_name": [
                ValidService.required,
                ValidService.checkSpaceString,
                ValidService.checkMaxLength(15),
                ValidService.checkVietNameseNoNumber
            ], // required Tên
            "last_name": [
                ValidService.required,
                ValidService.checkSpaceString,
                ValidService.checkVietNameseNoNumber
            ], // required Họ và đệm
            "full_name": [ValidService.required, ValidService.checkSpaceString], // required Họ tên đầy đủ
        },
        "avatar_id": [{
            required: true,
            message: "Vui lòng chọn ảnh",
            trigger: "change"
        }], // required Ảnh chân dung
        "birthday": [], // required Ngày sinh
        "gender": [ValidService.requiredChange], // required, min: 0, max: 2 Giới tính 0: nữ, 1: nam, 2: khác
        "identify_card": [ValidService.checkNumber], // required Số chứng mình thư, căn cước công dân
        "identify_before_img_id": [], // optional Ảnh cmt/cccd trước
        "identify_after_img_id": [], // optional Ảnh cmt/cccd sau
        "phone_number": [ValidService.checkPhone], // required Điện thoại
        "email": [ValidService.required, ValidService.checkSpaceString, ValidService.checkEmail], // required Email cá nhân
        "company_email": [ValidService.checkEmail], // optional Email công ty
        "address": [
            ValidService.checkSpaceString,
            ValidService.checkMaxLength(5000),
        ], // optional Địa chỉ
        "skype": [ValidService.checkSpaceString], // optional Skype
        "facebook": [ValidService.checkSpaceString], // optional facebook
    },
    "status": [ValidService.requiredChange], // optional Trạng thái làm việc
    "card_no": [ValidService.checkNumber], // optional Mã thẻ chấm công
    "job_info": // optional Thông tin công việc
        [{
        "kind_of_contract": [ValidService.requiredChange],
        "contract_type_id": [ValidService.required, ValidService.requiredChange], // required Loại hợp đồng
        "start_date": [ValidService.required, ValidService.requiredChange], // required Ngày bắt đầu
        "end_date": [], // optional Ngày kết thúc
        "official_labor_contract_signed_date": [], // optional Ngày kí HĐLĐ chính thức
        "branch_id": [], // optional Chi nhánh
        "department_id": [], // optional Phòng ban
        "position_id": [ValidService.requiredChange], // optional Chức vụ
        "direct_manager_id": [], // required Quản lý trực tiếp
    }],
    "qualification": // optional Trình độ chuyên môn
        [{
        "qualification_id": [ValidService.required, ValidService.requiredChange], // required Trình độ
        "major_id": [ValidService.required, ValidService.requiredChange], // required Chuyên ngành
        "issued_by": [ValidService.required, ValidService.checkSpaceString], // required Nơi cấp
        "issued_date": [ValidService.required, ValidService.requiredChange], // required Ngày cấp
        "note": [], // optional Ghi chú
    }],
    "certificate": // optional Chứng chỉ
        [{
        "name": [
            ValidService.required,
            ValidService.checkSpaceString
        ], // required Tên chứng chỉ
        "issued_by": [ValidService.required, ValidService.checkSpaceString], // required Nơi cấp
        "issued_date": [ValidService.required, ValidService.requiredChange], // required Ngày cấp
        "note": [], // optional Ghi chú
    }, ],
    "other_contact_info": // optional Thông tin liên hệ khác
        [{
        "full_name": [
            ValidService.required,
            ValidService.checkSpaceString,
            ValidService.checkVietNameseNoNumber
        ], // required Họ tên
        "relationship_id": [ValidService.required, ValidService.requiredChange], // required Quan hệ
        "phone_number": [ValidService.required, ValidService.checkSpaceString, ValidService.checkPhone], // required Điện thoại
        "address": [], // optional Địa chỉ
    }, ],
    "salary": // optional Thông tin về lương
    {
        "subsidies": [],
        "payment_method": [
            ValidService.checkSpaceString,
            ValidService.checkVietNameseHaveNumber
        ], // optional Hình thức chi trả
        "bank_name": [
            ValidService.checkSpaceString,
            ValidService.checkVietNameseHaveNumber
        ], // optional Tên ngân hàng
        "bank_account": [
            ValidService.checkNumber
        ], // optional Số ngân hàng
        "bank_branch": [
            ValidService.checkSpaceString,
            ValidService.checkVietNameseHaveNumber
        ], // optional Chi nhánh ngân hàng
        "coefficient_salary_id": [], // optional Hệ số lương
        "rank_salary_id": [], // optional Bậc lương
        "gross_salary": [], // optional Mức lương gross
        "insurance_salary": [], // optional Mức lương đóng bảo hiểm
        "subsidies_salary": // optional Lương trợ cấp
            [{
            "subsidies_salary_type_id": [], // optional Tên loại trợ cấp
            "value": [], // optional Giá trị trợ cấp
        }, ]
    },
    // "salary.subsidies_salary[0].subsidies_salary_type_id":[ValidService.required, ValidService.requiredChange],
    "dependent_person_info": // optional Thông tin người phụ thuộc
        [{
        "full_name": [
            ValidService.required,
            ValidService.checkSpaceString,
            ValidService.checkVietNameseNoNumber
        ], // required Tên người phụ thuộc
        "relationship_id": [ValidService.requiredChange], // required Mối quan hệ
        "registered_date": [ValidService.requiredChange], // required Ngày đăng ký
        "expired_date": [], // optional Ngày hết hạn
    }, ],
    "shift": [{
        "shift_id": [ValidService.required], // required Ca làm việc
        "start_time": [ValidService.required], // required Thời điểm bắt đầu
        "end_time": [], // optional Thời điểm kết thúc
        "is_need_checkin": [], // required Có cần chấm công không
        "number_of_late_minute": [], // optional Số phút cho phép đi muộn
        "number_of_leave_early_minute": [], // optional Số phút cho phép về sớm
    }, ],
    "disabled": [], // required Đã bị khóa chưa
    "social_networks": [],
    "seniority": [], // optional - Số năm thâm niên
    "start_work_date": [], // optional - Ngày đầu làm việc
    "insurance_book_number": [], // optional - Số sổ bảo hiểm
    "signature_image_id": [],
    "signature_image_full_id": [], // optional, ref: mushroom_file - Ảnh chữ ký đầy đủ có cả con dấu
};//dữ liệu thêm Thông tin công việc
model.dataJobInfo = {
  "kind_of_contract": undefined,
    "contract_type_id": undefined, // required Loại hợp đồng
    "start_date": undefined, // required Ngày bắt đầu
    "end_date": undefined, // optional Ngày kết thúc
    "official_labor_contract_signed_date": undefined, // optional Ngày kí HĐLĐ chính thức
    "branch_id": undefined, // optional Chi nhánh
    "department_id": undefined, // optional Phòng ban
    "position_id": undefined, // optional Chức vụ
    "direct_manager_id": undefined, // required Quản lý trực tiếp
}
model.validJobInfo = {
        "kind_of_contract": [ValidService.requiredChange],
        "contract_type_id": [ValidService.requiredChange], // required Loại hợp đồng
        "start_date": [ValidService.requiredChange], // required Ngày bắt đầu
        "end_date": [], // optional Ngày kết thúc
        "official_labor_contract_signed_date": [], // optional Ngày kí HĐLĐ chính thức
        "branch_id": [], // optional Chi nhánh
        "department_id": [], // optional Phòng ban
        "position_id": [ValidService.requiredChange], // optional Chức vụ
        "direct_manager_id": [], // required Quản lý trực tiếp
}//Dữ liệu thêm thông tin chấm công
model.dataShift = {
    "shift_id": undefined, // required Ca làm việc
    "start_time": undefined, // required Thời điểm bắt đầu
    "end_time": undefined, // optional Thời điểm kết thúc
    "number_of_late_minute": undefined, // optional Số phút cho phép đi muộn
    "number_of_leave_early_minute": undefined, // optional Số phút cho phép về sớm
    "is_need_checkin": true, // required Có cần chấm công không
}
model.validShift = {
        "shift_id": [ValidService.requiredChange], // required Ca làm việc
        "start_time": [ValidService.requiredChange], // required Thời điểm bắt đầu
        "end_time": [], // optional Thời điểm kết thúc
        "number_of_late_minute": [], // optional Số phút cho phép đi muộn
        "number_of_leave_early_minute": [], // optional Số phút cho phép về sớm
        "is_need_checkin": [], // required Có cần chấm công không
}//Dữ liệu thêm trình độ chuyên môn
model.dataQualification = {
    "qualification_id": undefined, // required Trình độ
    "major_id": undefined, // required Chuyên ngành
    "issued_by": undefined, // required Nơi cấp
    "issued_date": undefined, // required Ngày cấp
    "note": undefined, // optional Ghi chú
}
model.validQualification = {
        "qualification_id": [ValidService.requiredChange], // required Trình độ
        "major_id": [ValidService.requiredChange], // required Chuyên ngành
        "issued_by": [
            ValidService.required,
            ValidService.checkSpaceString,
            ValidService.checkVietNameseHaveNumber
        ], // required Nơi cấp
        "issued_date": [ValidService.requiredChange], // required Ngày cấp
        "note": [
            ValidService.checkSpaceString,
            ValidService.checkMaxLength(50000)
        ], // optional Ghi chú
}//Dữ liệu thêm chững chỉ
model.dataCertificate = {
    "name": undefined, // required Tên chứng chỉ
    "issued_by": undefined, // required Nơi cấp
    "issued_date": undefined, // required Ngày cấp
    "note": undefined, // optional Ghi chú
}
model.validCertificate = {
        "name": [
            ValidService.required,
            ValidService.checkSpaceString,
            ValidService.checkVietNameseHaveNumber
        ], // required Tên chứng chỉ
        "issued_by": [
            ValidService.required,
            ValidService.checkSpaceString,
            ValidService.checkVietNameseHaveNumber
        ], // required Nơi cấp
        "issued_date": [ValidService.required, ValidService.requiredChange], // required Ngày cấp
        "note": [ValidService.checkSpaceString], // optional Ghi chú
}//Dữ liệu thêm thông tin liên hệ khác
model.dataOtherContactInfo = {
    "full_name": undefined, // required Họ tên
    "relationship_id": undefined, // required Quan hệ
    "phone_number": undefined, // required Điện thoại
    "address": undefined, // optional Địa chỉ
}
model.validOtherContactInfo = {
        "full_name": [
            ValidService.required,
            ValidService.checkSpaceString,
            ValidService.checkVietNameseHaveNumber
        ], // required Họ tên
        "relationship_id": [ValidService.requiredChange], // required Quan hệ
        "phone_number": [ValidService.required, ValidService.checkSpaceString, ValidService.checkPhone], // required Điện thoại
        "address": [
            ValidService.checkSpaceString,
            ValidService.checkMaxLength(5000)
        ], // optional Địa chỉ
}//Dữ liệu thêm THÔNG TIN NGƯỜI PHỤ THUỘC
model.dataDependentPersonInfo = {
    "full_name": undefined, // required Tên người phụ thuộc
    "relationship_id": undefined, // required Mối quan hệ
    "registered_date": undefined, // required Ngày đăng ký
    "expired_date": undefined, // optional Ngày hết hạn
}
model.validDependentPersonInfo = {
        "full_name": [
            ValidService.required,
            ValidService.checkSpaceString,
            ValidService.checkVietNameseNoNumber
        ], // required Tên người phụ thuộc
        "relationship_id": [ValidService.requiredChange], // required Mối quan hệ
        "registered_date": [ValidService.requiredChange], // required Ngày đăng ký
        "expired_date": [], // optional Ngày hết hạn
}//Dữ liệu thêm trợ cấp
model.dataSubsidiesSalary = {
    "subsidies_salary_type_id": undefined, // required Tên loại trợ cấp
    "value": undefined, // required Giá trị trợ cấp
}
model.validSubsidiesSalary = {
    "subsidies_salary_type_id": [], // required Tên loại trợ cấp
    "value": [], // required Giá trị trợ cấp
}//Dữ liệu form tài sản
model.dataEmployeeAsset = {
    "asset_id": null, // required - Mã tài sản
    "employee_id": null, // required, ref: mushroom_user - Mã nhân viên
    "company_id": null, // required, ref: company - Công ty Id
    "type": null, // required, enum(ALLOCATION, RECALL, BROKEN) - Loại CẤP PHÁT, THU_HOI, BÁO HỎNG, THANH LÝ
    "requested_date": null, // required - Ngày yêu cầu
    "confirmed_date": null, // optional - Ngày xác nhận
    "requested_user_id": null, // optional, ref: mushroom_user - Người yêu cầu
    "confirmed_user_id": null, // optional, ref: mushroom_user - Người xác nhận
    "status": null, // required, enum(NEW, BROKEN_REPORT, BROKEN_CONFIRMED, RECALL_REPORT, RECALL_CONFIRMED, ALLOCATION_REQUEST, ALLOCATION_CONFIRMED, LIQUIDATION) - Mới, báo hỏng, xác nhận hỏng, báo thu hồi, xác nhận thu hồi, báo cấp phát, xác nhận cấp phát, thanh lý
    "asset_name": null,
    "description": null, // optional - Description
    "identity": null, // required Định danh
    "file_ids": [], // optional - Ảnh tài sản
    "origin_price": null, // optional - Giá ban đầu
    "is_atrophy": null, // optional - Có tiêu hao hay không
    "expired_atrophy": null, // optional - Thời gian hết hạn tiêu hao
}
model.validEmployeeAsset = {
    asset_id: [ValidService.requiredChange], // required - Mã tài sản
    employee_id: [ValidService.requiredChange], // required, ref: mushroom_user - Mã nhân viên
    type: [ValidService.requiredChange], // required, enum(ALLOCATION, RECALL, BROKEN) - Loại CẤP PHÁT, THU_HOI, BÁO HỎNG, THANH LÝ
    requested_date: [ValidService.requiredChange], // required - Ngày yêu cầu
    // confirmed_date: [ValidService.requiredChange], // optional - Ngày xác nhận
    // requested_user_id: [ValidService.requiredChange], // optional, ref: mushroom_user - Người yêu cầu
    // confirmed_user_id: [ValidService.requiredChange], // optional, ref: mushroom_user - Người xác nhận
    status: [ValidService.requiredChange],
}
model.tableRulesEmployeeAsset = {
  data: [],
  lengthMenu: [20, 40, 80, 120, 200, 500],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 20,
  skip: 0,
  sort: "",
  defaultSort: ["", ""],
  filters: "",
  recordSelected: [],
  dataSearch: {
    value: {
      "emp_names": "",
      "asset_names": "",
      "name": "",
      "value": "",
      "type": "",
      "identity": "",
      "status": "",
      "is_broken": "",
    },
    valid: {
      "emp_names": [],
      "asset_names": [],
      "name": [],
      "value": [],
      "type": [],
      "identity": [ValidService.checkSpaceString, ValidService.checkSpaceStringCenter],
      "status": [],
      "is_broken": [],
    },
    operator: {
      "emp_names": "$vn_text=",
      "asset_names": "$vn_text=",
      "name": "$vn_text=",
      "value": "",
      "identity": ":regex_i:",
      "status": ":in:",
      "is_broken": "",
    }
  }
};

//Dữ liệu hợp đồng nhân viên
model.dataFormEmployeeContract = {
    "name": undefined, // required - Tên hợp đồng/văn bản
    "code": undefined, // optional - Số văn bản
    "type": undefined, // required, enum(CONTRACT, DOCUMENT) - Loại (CONTRACT/DOCUMENT)
    "company_id": undefined, // required - Công ty
    "employee_id": undefined, // required, ref: mushroom_user - Mã nhân viên
    "description": undefined, // optional - Mô tả
    "effective_date": undefined, // optional - Ngày hiệu lực
    "expiration_date": undefined, // optional - Ngày hết hiệu lực
    "file_ids": [], // optional - Files
}
model.validFormEmployeeContract = {
    "name": [ValidService.required, ValidService.checkVietNameseHaveNumber], // required - Tên hợp đồng/văn bản
    "code": [], // optional - Số văn bản, rule động theo loại
    "type": [ValidService.requiredChange], // required, enum(CONTRACT, DOCUMENT) - Loại (CONTRACT/DOCUMENT)
    "company_id": [ValidService.required], // required - Công ty
    "employee_id": [ValidService.required], // required, ref: mushroom_user - Mã nhân viên
    "description": [], // optional - Mô tả
    "effective_date": [], // optional - Ngày hiệu lực
    "expiration_date": [], // optional - Ngày hết hiệu lực
    "file_ids": [], // optional - Files
}
model.tableRulesEmployeeContract = {
    data: [],
    lengthMenu: [20, 40, 80, 120, 200, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 20,
    offset: 0,
    sort: "-created_at",
    defaultSort: ["created_at", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            "name": "",
            "code": "",
            "type": ""
        },
        valid: {
            "name": [],
            "code": [],
            "type": []
        },
        operator: {
            "name": "$vn_text=",
            "code": ":regex_i:",
            "type": ""
        }
    }
};// dữ liệu mẫu các form khác
model.dataFormOther = {};
// validation các form khác
model.validFormOther = {};

model.tableRulesDefault = {
    data: [],
    lengthMenu: [20, 40, 80, 120, 200, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 20,
    offset: 0,
    sort: "status_order,employee_no",
    defaultSort: [],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            "company_id": "",
            "job_info.branch_id": "",
            "job_info.department_id": "",
            "job_info.position_id": "",
            "job_info.status": "",
            "administrative_info.gender": "",
            'salary.insurance_salary': "",
            'job_info.contract_type_id': "",
            "start_date*end_date": "",
            "start_work_date": "",
            "condition": "",
            "name": "",
            "type": "",
            "identity": "",
            "status": "",
            "is_broken": "",
            "file_ids": ""
        },
        valid: {
            "company_id": [],
            "job_info.branch_id": [],
            "job_info.department_id": [],
            "job_info.position_id": [],
            "job_info.status": [],
            "administrative_info.gender": [],
            'salary.insurance_salary': [],
            'job_info.contract_type_id': [],
            "start_date*end_date": [],
            "start_work_date": [],
            "condition": [],
            "name": [],
            "type": [],
            "identity": [ValidService.checkSpaceString, ValidService.checkSpaceStringCenter],
            "status": [],
            "is_broken": [],
            "file_ids": []
        },
        operator: {
            "company_id": "",
            "job_info.branch_id": "",
            "job_info.department_id": "",
            "job_info.position_id": "",
            "job_info.status": "",
            "administrative_info.gender": "",
            "salary.insurance_salary": "is_null",
            'job_info.contract_type_id': "",
            "start_date*end_date": "contract_validity_period",
            "start_work_date": "start_work",
            "condition": "$vn_text=", //:regex:, $vn_text=Viêt nam
            "name": "$vn_text=",
            "identity": ":regex_i:",
            "status": ":in:",
            "is_broken": "",
            "file_ids": ""
        }
    }
};

model.tableRules = {
  data: [],
  lengthMenu: [20, 40, 80, 120, 200, 500],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 20,
  offset: 0,
  sort: "status_order,employee_no",
  defaultSort: [],
  filters: "",
  recordSelected: [],
  dataSearch: {
      value: {
          "company_id": "",
          "job_info.branch_id": "",
          "job_info.department_id": "",
          "job_info.position_id": "",
          "job_info.status": "",
          "administrative_info.gender": "",
          'salary.insurance_salary': "",
          'job_info.contract_type_id': "",
          "start_date*end_date": "",
          "start_work_date": "",
          "condition": "",
          "name": "",
          "type": "",
          "identity": "",
          "status": "",
          "is_broken": "",
      },
      valid: {
          "company_id": [],
          "job_info.branch_id": [],
          "job_info.department_id": [],
          "job_info.position_id": [],
          "job_info.status": [],
          "administrative_info.gender": [],
          'salary.insurance_salary': [],
          'job_info.contract_type_id': [],
          "start_date*end_date": [],
          "start_work_date": [],
          "condition": [],
          "name": [],
          "type": [],
          "identity": [ValidService.checkSpaceString, ValidService.checkSpaceStringCenter],
          "status": [],
          "is_broken": [],
      },
      operator: {
          "company_id": "",
          "job_info.branch_id": "",
          "job_info.department_id": "",
          "job_info.position_id": "",
          "job_info.status": "",
          "administrative_info.gender": "",
          "salary.insurance_salary": "is_null",
          "start_date*end_date": "contract_validity_period",
          "start_work_date": "start_work",
          'job_info.contract_type_id': ":in:",
          "condition": "$vn_text=", //:regex:, $vn_text=Viêt nam
          "name": "$vn_text=",
          "identity": ":regex_i:",
          "status": ":in:",
          "is_broken": "",
      }
  }
};

export default model;
